import Header from "./components/Header";
import Hero from "./components/Hero";
import SectionList from "./components/SectionList";
import DramaReel from "./components/DramaReel";
import Timeline from "./components/Timeline";
import FigureArchive from "./components/FigureArchive";
import HeatRank from "./components/HeatRank";
import CtaDownload from "./components/CtaDownload";
import Faq from "./components/Faq";
import Footer from "./components/Footer";
import { streamerList, celebrityList } from "@/mocks/blackdata";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      {/* 更新条压顶 + 主导航 */}
      <Header />

      {/* 首屏：分区入口条 + 头条专题 + 最新实锤动态 */}
      <Hero />

      {/* 分区一：主播塌房实锤（标题+摘要 长条列表） */}
      <SectionList
        id="streamer"
        eyebrow="主播塌房实锤"
        title="主播塌房实锤 · 逐条可核对"
        lead="连麦录音、聊天记录、脚本比对，塌房不是一句澄清就能翻篇。"
        items={streamerList}
        variant="rows"
        sideNote="本分区实锤 5 条 / 存疑 2 条"
        sideTag="收录范围：情绪类 · 带货类 · 户外类主播"
        accent="primary"
      />

      {/* 分区二：网红翻车名单（封面卡片） */}
      <SectionList
        id="celebrity"
        eyebrow="网红翻车名单"
        title="网红翻车名单 · 人设裂开现场"
        lead="滤镜、剧本、人设全记录，翻车前先存档，别让删帖毁证据。"
        items={celebrityList}
        variant="cards"
        sideNote="本分区实锤 3 条 / 证据在途 1 条"
        sideTag="收录范围：颜值 · 舞蹈 · 短剧 · 穿搭"
        accent="secondary"
      />

      {/* 分区三：直播丑闻录屏（深色切片库） */}
      <DramaReel />

      {/* 分区四：按人物梳理争议往事（实锤时间线） */}
      <Timeline />

      {/* 分区五：人物档案专区 */}
      <FigureArchive />

      {/* 分区六：热度榜 + 追更/投稿 */}
      <HeatRank />

      {/* 分区七：素材包下载（入口更醒目） */}
      <CtaDownload />

      {/* 分区八：使用指南 FAQ */}
      <Faq />

      <Footer />
    </div>
  );
}